import setHelpText from './setHelpText';
import { pushAccountCreated, pushLeadCreated } from './sendToGtm';
import {
  getVisitorId, getReferer, getLandingPage, getEmailRequired, getPassword
} from '../../leadform/models/form';
import { isLoading, setLoading } from '../../principles/animations/loading';
import fullNameParts from '../../principles/form/fullNameParts';
import { formFieldValue } from '../../principles/selectors/formFieldValue';
import { createUserAsync } from '../../principles/form/accountApi';
import texts from './texts';
import {
  getAdditionalFormFields,
  additionalFormFieldsAsString
} from '../../principles/form/additionalFormFields';
import { sendToActionTracker } from '../../principles/event-tracking';
import getLeadformVersion from '../../leadform/models/metadata/get_leadform_version';
import dispatchCustomEvent from '../../principles/events/dispatchCustomEvent';

/**
  * Handle submission from account panel in order to interrupt it and create new account.
  */
 export default function handleAccountSubmission(event) {
  const { form } = event.detail;
  event.preventDefault(); // do not proceed
  if(!isLoading(form)) {
    postNewUser(form, event.detail.clientType || 'homepage_client');
  }
}

export function postNewUser(form, clientType) {
  if(!isLoading(form)) {
    setLoading(form);

    const [firstName, lastName] = fullNameParts(formFieldValue(form, 'full_name'));
    const additionalFormFields = getAdditionalFormFields(form);

    return createUserAsync({
      type: clientType,
      first_name: firstName,
      last_name: lastName,
      email: getEmailRequired(form),
      password: getPassword(form),
      message: additionalFormFieldsAsString(additionalFormFields),
      cookies: {
        visitor_id: getVisitorId(form),
        referer: getReferer(form),
        landing_page: getLandingPage(form)
      }
    })
      .then(handleCreateUser(form))
      .catch(catchCreateUserError(form));
  }
}

const handleCreateUser = (form) => (json) => {
  pushAccountCreated(form, { account_id: json.userID });
  pushLeadCreated(form, { lead_type: 'classes' });

  sendToActionTracker(
    'account-created',
    getLeadformVersion(form),
    { userId: json.userID }
  ).then(() => {
    dispatchCustomEvent(form, 'mslf.afterCreateUser', { form, userId: json.userID });
  });
};

export const catchCreateUserError = (form) => (error) => {
  if(window.newrelic) window.newrelic.noticeError(error);
  console.error(error);
  setLoading(form, false);
  setHelpText(form, texts.errorCreatingUser);
};
